/**
 * Partner Bank Account Service
 * API service for managing partner bank accounts
 * Used by both Service Partners and Channel Partners
 */

import AppService from '../Configurations/Appservice';

const BASE_URL = '/v1/partner-bank-accounts';

export const PartnerBankAccountService = {
  /**
   * Get all bank accounts for a partner organization
   */
  getByOrganisation: async (organisationId) => {
    const response = await AppService.get(`${BASE_URL}/partner/${organisationId}`);
    return Array.isArray(response) ? response : response?.data || [];
  },

  /**
   * Get active bank accounts only
   */
  getActiveByOrganisation: async (organisationId) => {
    const response = await AppService.get(`${BASE_URL}/partner/${organisationId}/active`);
    return Array.isArray(response) ? response : response?.data || [];
  },

  /**
   * Get primary/default bank account
   */
  getPrimaryByOrganisation: async (organisationId) => {
    try {
      const response = await AppService.get(`${BASE_URL}/partner/${organisationId}/primary`);
      return response;
    } catch (error) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  /**
   * Get a single bank account by ID
   */
  getById: async (accountId) => {
    const response = await AppService.get(`${BASE_URL}/${accountId}`);
    return response;
  },

  /**
   * Create a new bank account
   */
  create: async (organisationId, bankAccountData) => {
    const response = await AppService.post(`${BASE_URL}/partner/${organisationId}`, bankAccountData);
    return response;
  },

  /**
   * Update an existing bank account
   */
  update: async (accountId, bankAccountData) => {
    const response = await AppService.put(`${BASE_URL}/${accountId}`, bankAccountData);
    return response;
  },

  /**
   * Set a bank account as primary/default
   */
  setPrimary: async (accountId) => {
    const response = await AppService.put(`${BASE_URL}/${accountId}/set-primary`);
    return response;
  },

  /**
   * Deactivate (soft delete) a bank account
   */
  deactivate: async (accountId) => {
    const response = await AppService.put(`${BASE_URL}/${accountId}/deactivate`);
    return response;
  }
};

export default PartnerBankAccountService;
